import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BlockService} from '../../service/BlockService';
import {UserService} from '../../service/UserService';
import {EmitterService} from '../../service/EmitterService';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DATE_DEFAULT_FORMAT, DATE_D_M_Y_SLASH_FORMAT } from '../../model/commons/DateConstants';
import { TimeZoneService } from '../../service/TimeZoneService';
import { OpenFicheService } from '../../service/open-fiche.service';
import { LoggerService } from '../../service/LoggerService';
import { _ } from 'underscore';
import { DATE_FICHE_LABEL, DATE_DEMANDE_LABEL } from '../../helpers/GlobalConstants';
import { MessageService } from '../../service/message.service';
import { ObjectNotificationService } from '../../service/obj-notification.service';
import { ValidateDemandeDialogComponent } from '../block-temps/validate-demande-dialog/validate-demande-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-unlock-requests-history',
  templateUrl: './unlock-requests-history.component.html',
  styleUrls: ['./unlock-requests-history.component.css']
})
export class UnlockRequestsHistoryComponent implements OnInit, AfterViewInit {
  displayedColumns = ['demandeur', 'agent', DATE_FICHE_LABEL, DATE_DEMANDE_LABEL, 'motif', 'status', 'action'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource();
  data;
  @ViewChild(MatSort) sort: MatSort;

  statusList = ['VALIDATED', 'REJECTED_UNLOCKING' ];

  public Display = {
    row: ['Réalisé validé'],
    breaks: false,
    header: true,
    paginator: false,
    buttons: {
      valider: false,
      claim: false
    },
    styles: {
      margin: {top: -10, right: 40, bottom: 20, left: 100},
      height: '100px'
    },
    dialog: false
  };
  searchRequest = new FormGroup({
    agent: new FormControl(''),
    status: new FormControl(''),
    demandeur: new FormControl(''),
    dateDebutFiche: new FormControl(''),
    dateFinFiche: new FormControl(''),
    dateDebutDemande: new FormControl(''),
    dateFinDemande: new FormControl('')
  })
  loading = false;
  basicDataSource: any;
  constructor(public router: Router,
              public   activatedRoute: ActivatedRoute,
              private blockservice: BlockService,
              private messageService: MessageService,
              private user: UserService,
              private emit: EmitterService,
              private tzService: TimeZoneService,
              public dialog: MatDialog,
              private openFicheService: OpenFicheService,
              private LOG: LoggerService,
              private translate: TranslateService,
              private objNotificationService: ObjectNotificationService) {


        // console.log(23, 26, this.tzService.getReopenFichePeriod(23, 26));
        // console.log(2, 14, this.tzService.getReopenFichePeriod(2, 14));
        // console.log(6, 2, this.tzService.getReopenFichePeriod(6, 2));

  }

  ngOnInit() {
    this.loading = true;
    this.openFicheService.getUnlockRequestsToHistory().subscribe(res => {
      this.basicDataSource = [...res.filter(m=> m.status !== 'PENDING')];
      this.applyFilter();
      this.loading = false;
    })
    this.messageService.getMessage().subscribe(msg => {
      this.loading = msg && msg.text == 'LOADING'
    })
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  formatDate(date: string){
    return moment(date).format(DATE_DEFAULT_FORMAT)
  }


  applyFilter() {
    this.dataSource.data = [...this.basicDataSource];
    // MatTableDataSource defaults to lowercase matches
    let mapValues = Object.entries(this.searchRequest.controls).filter(control => control[1].value).map(entry => {
      return {
        key: entry[0],
        entry: entry[1].value
      }
    });
    if (mapValues.filter(m=> m.key == "status" && m.entry<=0).length>0)
      mapValues = mapValues.filter(m=> m.key != "status");

    if(mapValues && mapValues.length > 0)
      this.dataSource.data = this.blockservice.filterData(mapValues,this.dataSource.data);
  }

  sendData(element){
    this.objNotificationService.sendObject(element);
  }

  reset(){
    this.ngOnInit();
  }

  getStatus() {
    const translate = this.translate.translations[this.translate.currentLang];
    if (this.searchRequest.value && this.searchRequest.value.status)
      return this.searchRequest.value.status.length == 1?translate.INJECTION[this.searchRequest.value.status[0]]:
        translate.INJECTION[this.searchRequest.value.status[0]]+','+ translate.INJECTION[this.searchRequest.value.status[1]];
    return "";

  }

}



// WEBPACK FOOTER //
// ./src/app/view/unlock-requests-history/unlock-requests-history.component.ts